import { MobileState } from "./mobile.types";

export const mobileInitialState: MobileState = {
  isPurePage: false,
  isMobileAi: false,
  token: null,
};
